import React, { useRef } from 'react';
import {
  Waves,
  Home,
  TrendingUp,
  Building,
  Trees,
  Palmtree,
  Droplet,
  Sun,
  Mountain,
  Star,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';
import { Button } from './ui/button';
import { mockCategories } from '../mock';

const iconMap = {
  waves: Waves,
  home: Home,
  'trending-up': TrendingUp,
  building: Building,
  trees: Trees,
  'palm-tree': Palmtree,
  droplet: Droplet,
  sun: Sun,
  mountain: Mountain,
  star: Star,
};

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="border-b border-gray-200 bg-white sticky top-0 z-30">
      <div className="max-w-[1760px] mx-auto px-6 sm:px-10 lg:px-20 relative">
        <div className="flex items-center gap-2">
          {/* Scroll Left Button */}
          <Button
            onClick={() => scroll('left')}
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full flex-shrink-0 hover:bg-gray-100 border border-gray-300 bg-white shadow-sm"
          >
            <ChevronLeft className="w-4 h-4" />
          </Button>

          {/* Categories Scroll Container */}
          <div
            ref={scrollContainerRef}
            className="flex gap-8 overflow-x-auto scrollbar-hide py-4 flex-1"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {/* All Categories */}
            <button
              onClick={() => onCategoryChange('all')}
              className={`flex flex-col items-center gap-2 pb-3 border-b-2 transition-all duration-200 flex-shrink-0 group ${
                selectedCategory === 'all'
                  ? 'border-gray-900'
                  : 'border-transparent hover:border-gray-300'
              }`}
            >
              <Star
                className={`w-6 h-6 transition-colors ${
                  selectedCategory === 'all'
                    ? 'text-gray-900'
                    : 'text-gray-500 group-hover:text-gray-700'
                }`}
              />
              <span
                className={`text-xs font-medium whitespace-nowrap transition-colors ${
                  selectedCategory === 'all'
                    ? 'text-gray-900'
                    : 'text-gray-500 group-hover:text-gray-700'
                }`}
              >
                All
              </span>
            </button>

            {mockCategories.map((category) => {
              const IconComponent = iconMap[category.icon];
              return (
                <button
                  key={category.id}
                  onClick={() => onCategoryChange(category.id)}
                  className={`flex flex-col items-center gap-2 pb-3 border-b-2 transition-all duration-200 flex-shrink-0 group ${
                    selectedCategory === category.id
                      ? 'border-gray-900'
                      : 'border-transparent hover:border-gray-300'
                  }`}
                >
                  {IconComponent && (
                    <IconComponent
                      className={`w-6 h-6 transition-colors ${
                        selectedCategory === category.id
                          ? 'text-gray-900'
                          : 'text-gray-500 group-hover:text-gray-700'
                      }`}
                    />
                  )}
                  <span
                    className={`text-xs font-medium whitespace-nowrap transition-colors ${
                      selectedCategory === category.id
                        ? 'text-gray-900'
                        : 'text-gray-500 group-hover:text-gray-700'
                    }`}
                  >
                    {category.label}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Scroll Right Button */}
          <Button
            onClick={() => scroll('right')}
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full flex-shrink-0 hover:bg-gray-100 border border-gray-300 bg-white shadow-sm"
          >
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
